import { onBeforeUnmount, ref, toValue, watch } from 'vue';

export const useDebouncedRef = (source, delay) => {
  const debounced = ref(toValue(source));
  let timerId = null;

  watch(
    () => toValue(source),
    (value) => {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        debounced.value = value;
      }, delay);
    }
  );

  onBeforeUnmount(() => clearTimeout(timerId));

  return debounced;
};
